import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useUserLoginStore = defineStore('userLogin', () => {
    const isOpened = ref(false);
    const name = ref('');
    const password = ref('');
    const callback = ref(null);
    const isLoading = ref(false);

    const reset = () => {
        isOpened.value = false;
        name.value = '';
        password.value = '';
        callback.value = null;
        isLoading.value = false;
    };

    const close = result => {
        isOpened.value = false;
        callback.value && callback.value(result);
    };

    const show = params => new Promise(r => {
        reset();

        isOpened.value = true;
        callback.value = r;
    });

    return {
        isOpened, name, password, isLoading,
        show, close, reset,
    };
});
